<template>
    <kgr-dropdown
        inline
        display="name"
        :options="options"
        :value="value"
        :loading="loading"
        no-null-option
        @input="$emit('input', $event)"
    />
</template>

<script>
import Dropdown from './Dropdown.vue';
import KindergartenGroup from '../../../../js/dto/KindergartenGroup.js';
import axios from 'axios';

export default {
    components: {
        'kgr-dropdown': Dropdown,
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: () => {
                return null;
            }
        },
        kindergartenId: {
            type: Number,
            required: true,
        },
        defaultText: {
            type: [String, null],
            required: false,
            default: null
        },
    },
    data() {
        return {
            loading: false,
            options: [],
        }
    },
    created() {
        this.loading = true;
        axios
            .get(`/kindergartens/${this.kindergartenId}/groups`)
            .then(response => {
                const groups = response.data.data.map(data => KindergartenGroup.fromData(data));
                const nullOption = { id: null, name: this.$t('Alle Gruppen') };
                this.options = [nullOption, ...groups];

                if (this.value === null) {
                    this.$emit('input', nullOption);
                    this.$nextTick(() => {
                        this.$emit('post-input', nullOption);
                    })
                }
            })
            .catch(() => this.$notify.error('error.loadingData'))
            .finally(() => this.loading = false);
    },
}
</script>
